export default __webpack_public_path__ + "39c689a0bea9cbc875f8bb1fd7ad8f4e.png";